module.exports = __webpack_public_path__ + "static/media/pinterest.450618e4.svg";